import { toast } from 'sonner'

export function getErrorMessage(error: unknown): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'data' in error.response
  ) {
    const payload = error.response.data as { error?: string; message?: string }
    return payload.error || payload.message || 'No se pudo procesar la solicitud'
  }
  return 'No se pudo procesar la solicitud'
}

/** Pass a caught error (formatted via getErrorMessage) or a plain string. */
export function toastError(error: unknown): void {
  toast.error(typeof error === 'string' ? error : getErrorMessage(error))
}

export function toastSuccess(message: string): void {
  toast.success(message)
}

export { toast }
